import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModalTemplate from './ModalTemplate';

const DeleteStoreModal = ({
  open,
  store,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation('clients');

  if (!store) return null;

  const customActions = (
    <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
      <Button
        variant="outlined"
        color="inherit"
        onClick={onClose}
        disabled={isSubmitting}
        size="small"
      >
        {t('deleteStoreModal.cancel', 'Cancelar')}
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={isSubmitting}
        startIcon={<DeleteIcon />}
        size="small"
      >
        {t('deleteStoreModal.confirm', 'Eliminar Loja')}
      </Button>
    </Box>
  );

  return (
    <ModalTemplate
      open={Boolean(open)}
      title={t('deleteStoreModal.title', 'Eliminar Loja')}
      size="xs"
      icon={<DeleteIcon color="error" />}
      onClose={onClose}
      customActions={customActions}
      content={
        <Box sx={{ py: 1 }}>
          <Typography variant="body1">
            {t('deleteStoreModal.prompt', 'Tem a certeza que pretende eliminar a loja')} <strong>{store?.name}</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t('deleteStoreModal.irreversible', 'Esta ação é irreversível.')}
          </Typography>
        </Box>
      }
    />
  );
};

DeleteStoreModal.propTypes = {
  open: PropTypes.bool,
  store: PropTypes.object,
  isSubmitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteStoreModal;
